import React from "react";
import type { DeliveryTimeSlot } from "../../server/StoreInfoRequests";
import { formatLocalDate, parseDate } from "../../utils/DateUtil";
import { isValid } from "date-fns";

export type DeliveryTimeSlotsProps = {
	date: Date;
	timeSlots: DeliveryTimeSlot[];
	iconClass?: string;
};

export const DeliveryTimeSlots = ({ date, timeSlots, iconClass }: DeliveryTimeSlotsProps) => {
	return (
		<span className="text-overflow-ellipsis">
			{iconClass ? (
				<span>
					<i className={iconClass} data-testid={"icon-elem"} />
					&nbsp;
				</span>
			) : null}
			{formatTimeSlots(date, timeSlots)}
		</span>
	);
};
export function formatTimeSlots(date: Date, timeSlots: DeliveryTimeSlot[]): string {
	return timeSlots
		.map(({ fromUtc, untilUtc }) => `${getLocalTime(date, fromUtc)} - ${getLocalTime(date, untilUtc)}`)
		.join(", ");
}

function getLocalTime(date: Date, utcTime: string): string {
	const dateCopy = new Date(date);
	const utcDate = parseDate(utcTime, "HH:mm:ss");
	if (!isValid(utcDate)) {
		return "";
	}
	dateCopy.setUTCHours(utcDate.getHours(), utcDate.getMinutes(), utcDate.getSeconds(), utcDate.getMilliseconds());
	return formatLocalDate(dateCopy, "HH:mm");
}
